import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as toolbarNotificationsState from '../reducers';
import * as toolbarNotificationsReducer from '../reducers/toolbar-notifications.reducer';

export const selectToolbarNotifications = createSelector(
  toolbarNotificationsState.getToolbarNotificationsState,
  toolbarNotificationsReducer.getToolbarNotifications
);
